import { STATUS_META } from "@/data/content";

export function StatusBadge({ status, testid }) {
  const meta = STATUS_META[status] || { label: status, color: "bg-white/10 text-white/70 border-white/20" };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border ${meta.color}`}
    >
      {meta.label}
    </span>
  );
}
